export default __webpack_public_path__ + "static/media/bmw.893ecade.png";